import Vue from 'vue';

import Plugin from '../client-vue';

// $config represents the public runtime configuration
// https://nuxtjs.org/docs/configuration-glossary/configuration-runtime-config/
export default ({ $config }) => {
  const { environment } = $config;
  Vue.use(Plugin, { environment });
};
